import { Component } from "@angular/core";

@Component({
  selector: "rich-text-editor",
  template:
    '<div class="inline-text-editor"  [froalaEditor]="_options" [(froalaModel)]="_innerValue"> </div>',
})
export class RichTextEditorComponent {
  _innerValue: string = "";
  _options: Object = {
    key: "RB3J4B17C10iB6E5E4H5I2I3A6B6C5C4C-11NGNe1IODMGYNSFKV==",
    toolbarButtons: [
      "fontFamily",
      "fontSizeEm",
      "lineHeight",
      "align",
      "color",
      "|",
      "bold",
      "italic",
      "underline",
      "strikeThrough",
      "|",
      "undo",
      "redo",
    ],
    colorsText: [
      "#e6292f",
      "#fd6721",
      "#feb839",
      "#fff64a",
      "#b6f263",
      "#52d15d",
      "#70d7da",
      "#4253bd",
      "#6d41a0",
      "#777777",
      "#ffffff",
      "#000000",
    ],
    colorsBackground: [
      "#e6292f",
      "#fd6721",
      "#feb839",
      "#fff64a",
      "#b6f263",
      "#52d15d",
      "#70d7da",
      "#4253bd",
      "#6d41a0",
      "#777777",
      "#ffffff",
      "#000000",
      "REMOVE",
    ],
    toolbarVisibleWithoutSelection: true,
    toolbarInline: true,
    colorsStep: 6,
    colorsHEXInput: false,
    charCounterCount: false,
    fontFamilySelection: true,
  };
}
